import { getTransformedSlider } from 'containers/QuestionnairePage/GenericQuestion/SliderQuestion/utils';
import { DEFAULT_RATING_STARS } from 'containers/QuestionnairePage/GenericQuestion/RatingQuestion/constants';

import {
  getTransformedABTestConcepts,
  getTransformedABTestAttributes,
  getDefaultABTestProperties,
  getDefaultConjointProperties,
  getDefaultConjointAttributes,
  getDefaultVanWestendorpProperties,
  getTransformedVanWestendorpAttributes,
  getTransformedVanWestendorpConcepts,
  getDefaultVanWestendorpQuestionMatrix,
  getDefaultMaxDiffProperties,
  getDefaultMaxDiffAttributes,
  getDefaultMaxDiffQuestionMatrix,
  getDefaultBipolarMatrix,
  getDefaultOpenEndedMatrix,
  getDefaultConstantSumMatrix,
  getDefaultDrillDownQuestionMatrix,
  getDefaultConversationalMatrix,
  getDefaultLoopAndMergeProperties,
  getDefaultLoopAndMergeConcepts,
  getDefaultLoopAndMergeAttributes,
} from 'containers/QuestionnairePage/QuestionGroup/utils';

import * as TYPES from './nodeTypes';
import * as PROPERTIES from './nodeProperties';
import * as FEATURES from './questionFeatures';

// TODO: fill the rest as progressing
export const NODE_FEATURE_SUPPORT = {
  [TYPES.QUESTION_SINGLE]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_CARRY_FORWARD,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_PREDEFINED_ANSWERS,
    FEATURES.FEATURE_ADD_OTHER,
    FEATURES.FEATURE_NONE_OF_THE_ABOVE,
    FEATURES.FEATURE_QUOTAS_SIMPLE,
    FEATURES.FEATURE_MINIMUM_RESPONSES,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_MULTIPLE]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_CARRY_FORWARD,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_PREDEFINED_ANSWERS,
    FEATURES.FEATURE_ADD_OTHER,
    FEATURES.FEATURE_NONE_OF_THE_ABOVE,
    FEATURES.FEATURE_ADD_LIMITS,
    FEATURES.FEATURE_QUOTAS_SIMPLE,
    FEATURES.FEATURE_MINIMUM_RESPONSES,
    FEATURES.FEATURE_QUOTA_ASSIGNMENT,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_OPEN_ENDED]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_LIMIT_TEXT_LENGTH,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_NUMERIC_OPEN_ENDED]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_DECIMAL_LIMIT,
    FEATURES.FEATURE_LIMIT_RANGE,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_SLIDER]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_SLIDER,
    FEATURES.FEATURE_PREDEFINED_ANSWERS,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_RATING]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_RATING,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_RANKING]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_CARRY_FORWARD,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_RANKING,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_PREDEFINED_ANSWERS,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_MATRIX_SINGLE]: [
    FEATURES.FEATURE_MATRIX,
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_CARRY_FORWARD,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_PREDEFINED_ANSWERS,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_NONE_OF_THESE,
    FEATURES.FEATURE_QUOTAS_SIMPLE,
    FEATURES.FEATURE_MINIMUM_RESPONSES,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_MATRIX_MULTIPLE]: [
    FEATURES.FEATURE_MATRIX,
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_CARRY_FORWARD,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_PREDEFINED_ANSWERS,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_NONE_OF_THESE,
    FEATURES.FEATURE_QUOTAS_SIMPLE,
    FEATURES.FEATURE_MINIMUM_RESPONSES,
    FEATURES.FEATURE_QUOTA_ASSIGNMENT,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_MATRIX_BIPOLAR]: [
    FEATURES.FEATURE_MATRIX_BIPOLAR,
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_PREDEFINED_ANSWERS,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_QUOTAS_SIMPLE,
    FEATURES.FEATURE_MINIMUM_RESPONSES,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_MATRIX_NUMERIC_OPEN_ENDED]: [
    FEATURES.FEATURE_MATRIX_NUMERIC_OPEN_ENDED,
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_CARRY_FORWARD,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_PREDEFINED_ANSWERS,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_MATRIX_OPEN_ENDED]: [
    FEATURES.FEATURE_MATRIX_OPEN_ENDED,
    FEATURES.FEATURE_LIMIT_TEXT_LENGTH,
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_CARRY_FORWARD,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_MATRIX_CONSTANT_SUM]: [
    FEATURES.FEATURE_MATRIX_CONSTANT_SUM,
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_CARRY_FORWARD,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_PREDEFINED_ANSWERS,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_NPS]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_DESCRIPTION]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.QUESTION_VAN_WESTENDORP]: [
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_VAN_WESTENDORP_QUESTION,
  ],
  [TYPES.QUESTION_MAXDIFF]: [
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_MAXDIFF_QUESTION,
  ],
  [TYPES.QUESTION_DRILLDOWN]: [
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
    FEATURES.FEATURE_DRILLDOWN_QUESTION,
    FEATURES.FEATURE_AB_SELECT_ATTRIBUTES,
  ],
  [TYPES.GROUP_BASIC]: [
    FEATURES.FEATURE_DISPLAY_SAME_PAGE,
    FEATURES.FEATURE_LOOP_MERGE,
    FEATURES.FEATURE_QUESTIONS,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
  ],
  [TYPES.GROUP_LOOP_MERGE]: [
    FEATURES.FEATURE_DISPLAY_SAME_PAGE,
    FEATURES.FEATURE_LOOP_MERGE,
    FEATURES.FEATURE_QUESTIONS,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
  ],
  [TYPES.GROUP_AB_TEST]: [
    FEATURES.FEATURE_AB_TEST,
    FEATURES.FEATURE_QUESTIONS,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
  ],
  [TYPES.GROUP_CONJOINT]: [
    FEATURES.FEATURE_DOE,
    FEATURES.FEATURE_NONE_OF_THE_ABOVE,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
  ],
  [TYPES.GROUP_VAN_WESTENDORP]: [
    FEATURES.FEATURE_VAN_WESTENDORP,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
  ],
  [TYPES.GROUP_MAXDIFF]: [
    FEATURES.FEATURE_DOE,
    FEATURES.FEATURE_MAXDIFF,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
  ],
  [TYPES.QUESTION_CONVERSATIONAL]: [
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_MATRIX_CONVERSATIONAL,
    FEATURES.FEATURE_QUOTAS_ADVANCED,
    FEATURES.FEATURE_ADVANCED_LOGIC,
    FEATURES.FEATURE_DISPLAY_LOGIC,
  ],
};

export const NODE_SCREENING_FEATURE_SUPPORT = {
  [TYPES.QUESTION_SINGLE]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_ADD_OTHER,
    FEATURES.FEATURE_NONE_OF_THE_ABOVE,
    FEATURES.FEATURE_QUOTAS_SCREENING,
  ],
  [TYPES.QUESTION_MULTIPLE]: [
    FEATURES.FEATURE_RECALL,
    FEATURES.FEATURE_ANSWERS,
    FEATURES.FEATURE_ADD_MEDIA,
    FEATURES.FEATURE_SHUFFLE,
    FEATURES.FEATURE_BATCH_ANSWERS,
    FEATURES.FEATURE_ADD_OTHER,
    FEATURES.FEATURE_NONE_OF_THE_ABOVE,
  ],
};

export const FEATURE_PROPERTIES = {
  [FEATURES.FEATURE_ANSWERS]: [PROPERTIES.PROPERTY_ANSWERS],
  [FEATURES.FEATURE_SHUFFLE]: [PROPERTIES.PROPERTY_SHUFFLE],
  [FEATURES.FEATURE_ADD_MEDIA]: [PROPERTIES.PROPERTY_MEDIA],
  [FEATURES.FEATURE_DECIMAL_LIMIT]: [PROPERTIES.PROPERTY_ALLOW_DECIMALS],
  [FEATURES.FEATURE_ADD_LIMITS]: [
    PROPERTIES.PROPERTY_MIN,
    PROPERTIES.PROPERTY_MAX,
  ],
  [FEATURES.FEATURE_LIMIT_RANGE]: [
    PROPERTIES.PROPERTY_MIN,
    PROPERTIES.PROPERTY_MAX,
  ],
  // min, max are expected on the question AND on the slider property for this
  // question property type. This should be deprecated in the future
  [FEATURES.FEATURE_SLIDER]: [
    PROPERTIES.PROPERTY_SLIDER,
    PROPERTIES.PROPERTY_MIN,
    PROPERTIES.PROPERTY_MAX,
  ],
  [FEATURES.FEATURE_RATING]: [PROPERTIES.PROPERTY_RATING_SIZE],
  [FEATURES.FEATURE_RANKING]: [PROPERTIES.PROPERTY_RANKING_OPTIONS],
  [FEATURES.FEATURE_MATRIX]: [
    PROPERTIES.PROPERTY_ANSWERS,
    PROPERTIES.PROPERTY_SCOREPOINTS,
    PROPERTIES.PROPERTY_MATRIX_STYLE,
  ],
  [FEATURES.FEATURE_MATRIX_BIPOLAR]: [
    PROPERTIES.PROPERTY_ANSWERS,
    PROPERTIES.PROPERTY_MATRIX,
  ],
  [FEATURES.FEATURE_MATRIX_OPEN_ENDED]: [
    PROPERTIES.PROPERTY_ANSWERS,
    PROPERTIES.PROPERTY_MATRIX,
  ],
  [FEATURES.FEATURE_MATRIX_NUMERIC_OPEN_ENDED]: [
    PROPERTIES.PROPERTY_ANSWERS,
    PROPERTIES.PROPERTY_MATRIX,
  ],
  [FEATURES.FEATURE_MATRIX_CONSTANT_SUM]: [
    PROPERTIES.PROPERTY_ANSWERS,
    PROPERTIES.PROPERTY_MATRIX,
  ],
  [FEATURES.FEATURE_MATRIX_CONVERSATIONAL]: [
    PROPERTIES.PROPERTY_ANSWERS,
    PROPERTIES.PROPERTY_MATRIX,
  ],
  [FEATURES.FEATURE_ADVANCED_LOGIC]: [],
  [FEATURES.FEATURE_CARRY_FORWARD]: [PROPERTIES.PROPERTY_CARRY_FORWARD],
  [FEATURES.FEATURE_QUESTIONS]: [
    PROPERTIES.PROPERTY_QUESTIONS,
    PROPERTIES.PROPERTY_SHUFFLE,
  ],
  [FEATURES.FEATURE_DISPLAY_SAME_PAGE]: [PROPERTIES.PROPERTY_DISPLAY_SAME_PAGE],
  [FEATURES.FEATURE_LOOP_MERGE]: [
    PROPERTIES.PROPERTY_LOOP_MERGE,
    PROPERTIES.PROPERTY_CONCEPTS,
    PROPERTIES.PROPERTY_ATTRIBUTES,
    PROPERTIES.PROPERTY_PROPERTIES,
  ],
  [FEATURES.FEATURE_AB_TEST]: [
    PROPERTIES.PROPERTY_CONCEPTS,
    PROPERTIES.PROPERTY_ATTRIBUTES,
    PROPERTIES.PROPERTY_PROPERTIES,
  ],
  [FEATURES.FEATURE_AB_SELECT_ATTRIBUTES]: [
    PROPERTIES.PROPERTY_ATTRIBUTES_SELECTED,
  ],
  [FEATURES.FEATURE_DOE]: [
    PROPERTIES.PROPERTY_ATTRIBUTES,
    PROPERTIES.PROPERTY_PROPERTIES,
    PROPERTIES.PROPERTY_QUESTIONS,
    PROPERTIES.PROPERTY_CONCEPTS,
    PROPERTIES.PROPERTY_SHUFFLE,
  ],
  [FEATURES.FEATURE_VAN_WESTENDORP]: [
    PROPERTIES.PROPERTY_CONCEPTS,
    PROPERTIES.PROPERTY_ATTRIBUTES,
    PROPERTIES.PROPERTY_PROPERTIES,
    PROPERTIES.PROPERTY_QUESTIONS,
    PROPERTIES.PROPERTY_ATTRIBUTES_SELECTED,
  ],
  [FEATURES.FEATURE_VAN_WESTENDORP_QUESTION]: [
    PROPERTIES.PROPERTY_MATRIX,
    PROPERTIES.PROPERTY_QUESTIONS_RELATED,
  ],
  [FEATURES.FEATURE_MAXDIFF_QUESTION]: [PROPERTIES.PROPERTY_MATRIX],
  [FEATURES.FEATURE_DRILLDOWN_QUESTION]: [PROPERTIES.PROPERTY_MATRIX],
  [FEATURES.FEATURE_LIMIT_TEXT_LENGTH]: [
    PROPERTIES.PROPERTY_MIN_LENGTH,
    PROPERTIES.PROPERTY_MAX_LENGTH,
  ],
  [FEATURES.FEATURE_QUOTAS_SCREENING]: [
    PROPERTIES.PROPERTY_QUOTA,
    PROPERTIES.PROPERTY_QUOTA_COLLECTED,
  ],
  [FEATURES.FEATURE_QUOTAS_SIMPLE]: [],
  [FEATURES.FEATURE_MINIMUM_RESPONSES]: [PROPERTIES.PROPERTY_QUOTA_LIMIT_TYPE],
  [FEATURES.FEATURE_QUOTA_ASSIGNMENT]: [
    PROPERTIES.PROPERTY_QUOTA_ASSIGNMENT_STRATEGY,
  ],
  [FEATURES.FEATURE_QUOTAS_ADVANCED]: [],
};

export const COMMON_QUESTION_PROPERTIES = [
  PROPERTIES.PROPERTY_ID,
  PROPERTIES.PROPERTY_PROMPT,
  PROPERTIES.PROPERTY_PROMPT_HTML,
  PROPERTIES.PROPERTY_IS_SCREENING,
  PROPERTIES.PROPERTY_IS_SCREENER_ACTIVE,
  PROPERTIES.PROPERTY_IS_FAVORITE,
  PROPERTIES.PROPERTY_TYPE,
  PROPERTIES.PROPERTY_PRISTINE_VALUES,
  PROPERTIES.PROPERTY_REF_ID,
  PROPERTIES.PROPERTY_GROUP_REF_ID,
  PROPERTIES.PROPERTY_HAS_PIPING,
  PROPERTIES.PROPERTY_ATTRIBUTES_SELECTED,
  PROPERTIES.PROPERTY_MEDIA,
  PROPERTIES.PROPERTY_ALIAS,
];
export const PERSISTED_QUESTION_PROPERTIES = [...COMMON_QUESTION_PROPERTIES];

export const NOT_PERSISTED_QUESTION_PROPERTIES_BY_TYPE = {
  [TYPES.QUESTION_NPS]: [
    PROPERTIES.PROPERTY_PROMPT,
    PROPERTIES.PROPERTY_PROMPT_HTML,
  ],
};
export const DEFAULT_PROPERTIES = {
  [FEATURES.FEATURE_ANSWERS]: { [PROPERTIES.PROPERTY_ANSWERS]: Array },
  [FEATURES.FEATURE_SHUFFLE]: { [PROPERTIES.PROPERTY_SHUFFLE]: 0 },
  [FEATURES.FEATURE_ADD_MEDIA]: { [PROPERTIES.PROPERTY_MEDIA]: undefined },
  [FEATURES.FEATURE_DECIMAL_LIMIT]: {
    [PROPERTIES.PROPERTY_ALLOW_DECIMALS]: undefined,
  },
  [FEATURES.FEATURE_ADD_LIMITS]: {
    [PROPERTIES.PROPERTY_MIN]: undefined,
    [PROPERTIES.PROPERTY_MAX]: undefined,
  },
  [FEATURES.FEATURE_LIMIT_RANGE]: {
    [PROPERTIES.PROPERTY_MIN]: undefined,
    [PROPERTIES.PROPERTY_MAX]: undefined,
  },
  [FEATURES.FEATURE_SLIDER]: {
    [PROPERTIES.PROPERTY_SLIDER]: () => getTransformedSlider(),
  },
  [FEATURES.FEATURE_RATING]: {
    [PROPERTIES.PROPERTY_RATING_SIZE]: DEFAULT_RATING_STARS,
  },
  [FEATURES.FEATURE_MATRIX]: {
    [PROPERTIES.PROPERTY_ANSWERS]: Array,
    [PROPERTIES.PROPERTY_SCOREPOINTS]: Array,
  },
  [FEATURES.FEATURE_MATRIX_BIPOLAR]: {
    [PROPERTIES.PROPERTY_ANSWERS]: Array,
    [PROPERTIES.PROPERTY_MATRIX]: getDefaultBipolarMatrix,
  },
  [FEATURES.FEATURE_MATRIX_OPEN_ENDED]: {
    [PROPERTIES.PROPERTY_ANSWERS]: Array,
    [PROPERTIES.PROPERTY_MATRIX]: getDefaultOpenEndedMatrix,
  },
  [FEATURES.FEATURE_MATRIX_NUMERIC_OPEN_ENDED]: {
    [PROPERTIES.PROPERTY_ANSWERS]: Array,
    [PROPERTIES.PROPERTY_MATRIX]: getDefaultOpenEndedMatrix,
  },
  [FEATURES.FEATURE_MATRIX_CONSTANT_SUM]: {
    [PROPERTIES.PROPERTY_ANSWERS]: Array,
    [PROPERTIES.PROPERTY_MATRIX]: getDefaultConstantSumMatrix,
  },
  [FEATURES.FEATURE_MATRIX_CONVERSATIONAL]: {
    answers: Array,
    matrix: getDefaultConversationalMatrix,
  },
  [FEATURES.FEATURE_ADVANCED_LOGIC]: {},
  [FEATURES.FEATURE_CARRY_FORWARD]: { carryForward: Array },
  [FEATURES.FEATURE_QUESTIONS]: {
    [PROPERTIES.PROPERTY_QUESTIONS]: Array,
    [PROPERTIES.PROPERTY_SHUFFLE]: 0,
  },
  [FEATURES.FEATURE_DISPLAY_SAME_PAGE]: { displaySamePage: false },
  [FEATURES.FEATURE_LOOP_MERGE]: {
    [PROPERTIES.PROPERTY_CONCEPTS]: getDefaultLoopAndMergeConcepts,
    [PROPERTIES.PROPERTY_ATTRIBUTES]: getDefaultLoopAndMergeAttributes,
    [PROPERTIES.PROPERTY_PROPERTIES]: getDefaultLoopAndMergeProperties,
  },
  [FEATURES.FEATURE_AB_TEST]: {
    [PROPERTIES.PROPERTY_CONCEPTS]: () => getTransformedABTestConcepts(),
    [PROPERTIES.PROPERTY_ATTRIBUTES]: () => getTransformedABTestAttributes(),
    [PROPERTIES.PROPERTY_PROPERTIES]: getDefaultABTestProperties,
  },
  [FEATURES.FEATURE_AB_SELECT_ATTRIBUTES]: {
    [PROPERTIES.PROPERTY_ATTRIBUTES_SELECTED]: Array,
  },
  [FEATURES.FEATURE_DOE]: {
    [PROPERTIES.PROPERTY_QUESTIONS]: Array,
    [PROPERTIES.PROPERTY_ATTRIBUTES]: getDefaultConjointAttributes,
    [PROPERTIES.PROPERTY_PROPERTIES]: getDefaultConjointProperties,
    [PROPERTIES.PROPERTY_CONCEPTS]: Array,
    [PROPERTIES.PROPERTY_SHUFFLE]: 0,
  },
  [FEATURES.FEATURE_VAN_WESTENDORP]: {
    [PROPERTIES.PROPERTY_CONCEPTS]: getTransformedVanWestendorpConcepts,
    [PROPERTIES.PROPERTY_ATTRIBUTES]: () =>
      getTransformedVanWestendorpAttributes(),
    [PROPERTIES.PROPERTY_PROPERTIES]: getDefaultVanWestendorpProperties,
    [PROPERTIES.PROPERTY_ATTRIBUTES_SELECTED]: Array,
    [PROPERTIES.PROPERTY_QUESTIONS]: Array,
  },
  [FEATURES.FEATURE_VAN_WESTENDORP_QUESTION]: {
    [PROPERTIES.PROPERTY_MATRIX]: getDefaultVanWestendorpQuestionMatrix,
    relatedQuestions: [],
  },
  [FEATURES.FEATURE_MAXDIFF]: {
    [PROPERTIES.PROPERTY_ATTRIBUTES]: getDefaultMaxDiffAttributes,
    [PROPERTIES.PROPERTY_PROPERTIES]: getDefaultMaxDiffProperties,
  },
  [FEATURES.FEATURE_MAXDIFF_QUESTION]: {
    [PROPERTIES.PROPERTY_MATRIX]: getDefaultMaxDiffQuestionMatrix,
  },
  [FEATURES.FEATURE_DRILLDOWN_QUESTION]: {
    [PROPERTIES.PROPERTY_MATRIX]: getDefaultDrillDownQuestionMatrix,
  },
  [FEATURES.FEATURE_LIMIT_TEXT_LENGTH]: {
    [PROPERTIES.PROPERTY_MIN_LENGTH]: undefined,
    [PROPERTIES.PROPERTY_MAX_LENGTH]: undefined,
  },
  [FEATURES.FEATURE_QUOTAS_SIMPLE]: {},
  [FEATURES.FEATURE_MINIMUM_RESPONSES]: {},
  [FEATURES.FEATURE_QUOTAS_ADVANCED]: {},
};

export const CONVERSION_SUPPORT = {
  [TYPES.QUESTION_SINGLE]: [TYPES.QUESTION_MULTIPLE],
  [TYPES.QUESTION_MULTIPLE]: [TYPES.QUESTION_SINGLE],
  [TYPES.QUESTION_OPEN_ENDED]: [
    TYPES.QUESTION_NUMERIC_OPEN_ENDED,
    TYPES.QUESTION_DESCRIPTION,
  ],
  [TYPES.QUESTION_NUMERIC_OPEN_ENDED]: [
    TYPES.QUESTION_OPEN_ENDED,
    TYPES.QUESTION_DESCRIPTION,
  ],
  [TYPES.QUESTION_DESCRIPTION]: [
    TYPES.QUESTION_OPEN_ENDED,
    TYPES.QUESTION_NUMERIC_OPEN_ENDED,
  ],
  [TYPES.QUESTION_MATRIX_SINGLE]: [TYPES.QUESTION_MATRIX_MULTIPLE],
  [TYPES.QUESTION_MATRIX_MULTIPLE]: [TYPES.QUESTION_MATRIX_SINGLE],
};

export const QUESTION_WITH_MEDIA_ANSWER = [
  TYPES.QUESTION_SINGLE,
  TYPES.QUESTION_MULTIPLE,
  TYPES.QUESTION_MATRIX_SINGLE,
  TYPES.QUESTION_MATRIX_MULTIPLE,
  TYPES.QUESTION_MATRIX_OPEN_ENDED,
  TYPES.QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
  TYPES.QUESTION_MATRIX_CONSTANT_SUM,
  TYPES.QUESTION_RANKING,
];

export const QUESTIONS_COLLAPSIBLE = {
  [TYPES.QUESTION_SINGLE]: true,
  [TYPES.QUESTION_MULTIPLE]: true,
  [TYPES.QUESTION_SLIDER]: true,
  [TYPES.QUESTION_RANKING]: true,
  [TYPES.QUESTION_MATRIX_MULTIPLE]: true,
  [TYPES.QUESTION_MATRIX_SINGLE]: true,
  [TYPES.QUESTION_MATRIX_BIPOLAR]: true,
  [TYPES.QUESTION_MATRIX_OPEN_ENDED]: true,
  [TYPES.QUESTION_MATRIX_NUMERIC_OPEN_ENDED]: true,
  [TYPES.QUESTION_MATRIX_CONSTANT_SUM]: true,
  [TYPES.QUESTION_VAN_WESTENDORP]: true,
  [TYPES.QUESTION_DRILLDOWN]: true,
  [TYPES.QUESTION_CONVERSATIONAL]: true,
};

export const QUESTIONS_SUPPORTING_LOGIC_ANSWERS = [
  TYPES.QUESTION_SINGLE,
  TYPES.QUESTION_MULTIPLE,
  TYPES.QUESTION_MATRIX_SINGLE,
  TYPES.QUESTION_MATRIX_MULTIPLE,
  TYPES.QUESTION_MATRIX_BIPOLAR,
  TYPES.QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
  TYPES.QUESTION_MATRIX_CONSTANT_SUM,
  TYPES.QUESTION_CONVERSATIONAL,
];

export const QUESTIONS_SUPPORTING_SHOW_HIDE_ANSWERS = [
  TYPES.QUESTION_SINGLE,
  TYPES.QUESTION_MULTIPLE,
  TYPES.QUESTION_RANKING,
  TYPES.QUESTION_MATRIX_SINGLE,
  TYPES.QUESTION_MATRIX_MULTIPLE,
  TYPES.QUESTION_MATRIX_OPEN_ENDED,
  TYPES.QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
  TYPES.QUESTION_MATRIX_CONSTANT_SUM,
  TYPES.QUESTION_MATRIX_BIPOLAR,
];

export const CARRY_FORWARD_FROM = {
  // key signifies the target node type (TO)
  // the array of value signifies the source node type (FROM)
  [TYPES.QUESTION_SINGLE]: [
    TYPES.QUESTION_SINGLE,
    TYPES.QUESTION_MULTIPLE,
    TYPES.QUESTION_RANKING,
    TYPES.QUESTION_OPEN_ENDED,
    TYPES.QUESTION_NUMERIC_OPEN_ENDED,
    TYPES.QUESTION_SLIDER,
    TYPES.QUESTION_MATRIX_SINGLE,
    TYPES.QUESTION_MATRIX_MULTIPLE,
    TYPES.QUESTION_MATRIX_BIPOLAR,
  ],
  [TYPES.QUESTION_MULTIPLE]: [
    TYPES.QUESTION_SINGLE,
    TYPES.QUESTION_MULTIPLE,
    TYPES.QUESTION_RANKING,
    TYPES.QUESTION_OPEN_ENDED,
    TYPES.QUESTION_NUMERIC_OPEN_ENDED,
    TYPES.QUESTION_SLIDER,
    TYPES.QUESTION_MATRIX_SINGLE,
    TYPES.QUESTION_MATRIX_MULTIPLE,
    TYPES.QUESTION_MATRIX_BIPOLAR,
  ],
  [TYPES.QUESTION_RANKING]: [
    TYPES.QUESTION_SINGLE,
    TYPES.QUESTION_MULTIPLE,
    TYPES.QUESTION_RANKING,
    TYPES.QUESTION_OPEN_ENDED,
    TYPES.QUESTION_NUMERIC_OPEN_ENDED,
    TYPES.QUESTION_SLIDER,
    TYPES.QUESTION_MATRIX_SINGLE,
    TYPES.QUESTION_MATRIX_MULTIPLE,
    TYPES.QUESTION_MATRIX_BIPOLAR,
  ],
  [TYPES.QUESTION_MATRIX_SINGLE]: [
    TYPES.QUESTION_SINGLE,
    TYPES.QUESTION_MULTIPLE,
    TYPES.QUESTION_RANKING,
    TYPES.QUESTION_OPEN_ENDED,
    TYPES.QUESTION_NUMERIC_OPEN_ENDED,
    TYPES.QUESTION_SLIDER,
    TYPES.QUESTION_MATRIX_SINGLE,
    TYPES.QUESTION_MATRIX_MULTIPLE,
  ],
  [TYPES.QUESTION_MATRIX_MULTIPLE]: [
    TYPES.QUESTION_SINGLE,
    TYPES.QUESTION_MULTIPLE,
    TYPES.QUESTION_RANKING,
    TYPES.QUESTION_OPEN_ENDED,
    TYPES.QUESTION_NUMERIC_OPEN_ENDED,
    TYPES.QUESTION_SLIDER,
    TYPES.QUESTION_MATRIX_SINGLE,
    TYPES.QUESTION_MATRIX_MULTIPLE,
  ],
  [TYPES.QUESTION_MATRIX_BIPOLAR]: [],
  [TYPES.QUESTION_MATRIX_OPEN_ENDED]: [
    TYPES.QUESTION_SINGLE,
    TYPES.QUESTION_MULTIPLE,
    TYPES.QUESTION_OPEN_ENDED,
    TYPES.QUESTION_NUMERIC_OPEN_ENDED,
    TYPES.QUESTION_SLIDER,
    TYPES.QUESTION_RANKING,
  ],
  [TYPES.QUESTION_MATRIX_NUMERIC_OPEN_ENDED]: [
    TYPES.QUESTION_SINGLE,
    TYPES.QUESTION_MULTIPLE,
    TYPES.QUESTION_OPEN_ENDED,
    TYPES.QUESTION_NUMERIC_OPEN_ENDED,
    TYPES.QUESTION_SLIDER,
    TYPES.QUESTION_RANKING,
  ],
  [TYPES.QUESTION_MATRIX_CONSTANT_SUM]: [
    TYPES.QUESTION_SINGLE,
    TYPES.QUESTION_MULTIPLE,
    TYPES.QUESTION_OPEN_ENDED,
    TYPES.QUESTION_NUMERIC_OPEN_ENDED,
    TYPES.QUESTION_SLIDER,
    TYPES.QUESTION_RANKING,
  ],
};

export const LOOP_AND_MERGE_FROM = [
  TYPES.QUESTION_SINGLE,
  TYPES.QUESTION_MULTIPLE,
  TYPES.QUESTION_RANKING,
  TYPES.QUESTION_OPEN_ENDED,
  TYPES.QUESTION_MATRIX_SINGLE,
  TYPES.QUESTION_MATRIX_MULTIPLE,
  TYPES.QUESTION_MATRIX_BIPOLAR,
  TYPES.QUESTION_SINGLE_PEEQ,
  TYPES.QUESTION_MULTIPLE_PEEQ,
];

export const NODES_SUPPORT_ANSWERS_WITH_MENTIONS = [
  TYPES.QUESTION_SINGLE,
  TYPES.QUESTION_MULTIPLE,
  TYPES.QUESTION_MATRIX_MULTIPLE,
  TYPES.QUESTION_MATRIX_BIPOLAR,
  TYPES.QUESTION_MATRIX_SINGLE,
  TYPES.QUESTION_MATRIX_CONSTANT_SUM,
  TYPES.QUESTION_MATRIX_OPEN_ENDED,
  TYPES.QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
  TYPES.QUESTION_RANKING,
];
